import { ReactNode } from 'react';

import { UserRole } from '@herond/shared/types/user';

import { HerondIcon, HerondIdIcon, HerondPortalIcon, SystemIcon } from '@assets';
import { ROUTE_PATH } from '@constants/route-path';

export interface DashboardItems {
  key: string;
  icon: ReactNode;
  label: string;
  path: string;
  allowedRoles: UserRole[];
}

export const dashboardItems: DashboardItems[] = [
  {
    key: 'point',
    icon: (
      <span>
        <HerondPortalIcon height={40} width={40} />
      </span>
    ),

    label: 'Point',
    path: ROUTE_PATH.POINT,
    allowedRoles: [UserRole.Admin, UserRole.Operator],
  },
  {
    key: 'user',
    icon: (
      <span>
        <SystemIcon height={40} width={40} />
      </span>
    ),
    label: 'User',
    path: ROUTE_PATH.USER + ROUTE_PATH.USER_MANAGEMENT,
    allowedRoles: [UserRole.Admin],
  },
  {
    key: 'id',
    icon: (
      <span>
        <HerondIdIcon height={40} width={40} />
      </span>
    ),
    label: 'Herond ID',
    path: ROUTE_PATH.ID,
    allowedRoles: [UserRole.Admin, UserRole.Operator],
  },
  {
    key: 'browser',
    icon: <HerondIcon height={40} width={40} />,
    label: 'Browser',
    path: ROUTE_PATH.BROWSER,
    allowedRoles: [UserRole.Admin, UserRole.Operator],
  },
];
